import postStyleGuideTheme from "@eisinc/XDL/PostStyle"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import preStyleGuideTheme from "@eisinc/XDL/PreStyle";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

setPreStyleGuideTheme(preStyleGuideTheme);
setPostStyleGuideTheme(postStyleGuideTheme);
